<template>
  <a-modal
    :get-container="modalRef"
    v-model:visible="visible"
    :mask-closable="false"
    title="添加车场"
    :after-close="afterClose"
  >
    <template #footer>
      <a-button :disabled="disabled" @click="visible = false">取消</a-button>
      <a-button :disabled="disabled" type="primary" @click="doSubmit"
        >确定</a-button
      >
    </template>
    <a-form :label-col="{ span: 4 }">
      <a-form-item label="车场名称" v-bind="validateInfos.name">
        <a-input
          v-model:value="parkingCurbVo.name"
          :maxlength="20"
          placeholder="车场名称"
          allow-clear
        ></a-input>
      </a-form-item>
      <a-form-item label="企业编号" v-bind="validateInfos.ltdCode">
        <a-input
          v-model:value="parkingCurbVo.ltdCode"
          :maxlength="50"
          placeholder="企业编号"
          allow-clear
        ></a-input>
      </a-form-item>
      <a-form-item label="车场编号" v-bind="validateInfos.code">
        <a-input
          v-model:value="parkingCurbVo.code"
          :maxlength="50"
          placeholder="车场编号"
          allow-clear
        ></a-input>
      </a-form-item>
      <a-form-item label="总车位数" v-bind="validateInfos.total">
        <a-input
          allow-clear
          :maxlength="11"
          v-model:value="parkingCurbVo.total"
          placeholder="总车位数"
        ></a-input>
      </a-form-item>
      <a-form-item label="收费规则" >
        <a-select
          v-model:value="parkingCurbVo.parkingLotBillRuleId"
          placeholder="收费规则"
          allow-clear
        >
          <a-select-option
            v-for="item in billRules"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="状态" v-bind="validateInfos.status">
        <a-select
          v-model:value="parkingCurbVo.status"
          placeholder="请选择"
          allow-clear
          :options="parkingStatus"
        ></a-select>
      </a-form-item>
      <a-form-item label="地址" v-bind="validateInfos.address">
        <a-input
          v-model:value="parkingCurbVo.address"
          placeholder="地址"
        ></a-input>
      </a-form-item>
      <a-form-item label="纬经度" v-bind="validateInfos.lngLat">
        <a-input
          v-model:value="parkingCurbVo.lngLat"
          placeholder="填写格式：经度,纬度"
        >
        </a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { ref, onMounted, reactive, toRefs, watch } from "vue";
import useParkingClosed from "@/hooks/parking/useParkingClosed";
import useValidateRules from "@/hooks/useValidateRules";
import useMessage from "@/hooks/useMessage";
import { Form } from "ant-design-vue";
import { allBillRules } from "@/api/parking/parkingLotBillRuleApi";
import { save } from "@/api/parking/parkingLotApi";
import { validNumber } from "../../../../utils/validateUtils";

const useForm = Form.useForm;
export default {
  name: "Add",
  props: ["modalRef"],
  emits: ["close"],
  setup(pros, { emit }) {
    const disabled = ref(false);
    const { parkingCurbVo, parkingStatus } = useParkingClosed();
    const billRules = reactive([]);
    const { parkingCloseRules } = useValidateRules();
    const { showErr, showConfirm, showLoading, closeLoading, showTipMessage } =
      useMessage();
    const { validateInfos, validate } = useForm(
      parkingCurbVo,
      parkingCloseRules,
    );
    const visible = ref(true);
    let refresh = false;
    const afterClose = () => {
      emit("close", refresh);
    };
    const doSubmit = () => {
      validate().then(async () => {
        if (!parkingCurbVo.latitude || !parkingCurbVo.longitude) {
          showTipMessage("请填写正确的经纬度", "error");
          return;
        }
        if (!validNumber(parkingCurbVo.total)) {
          showTipMessage("请填写正确的总车位数", "error");
          return;
        }
        let action = await showConfirm("添加新的车场?");
        if (action) {
          disabled.value = true;
          await showLoading();
          try {
            let obj = {
              name: parkingCurbVo.name,
              ltdCode: parkingCurbVo.ltdCode,
              code: parkingCurbVo.code,
              total: parkingCurbVo.total,
              type: parkingCurbVo.type,
              address: parkingCurbVo.address,
              longitude: parkingCurbVo.longitude,
              latitude: parkingCurbVo.latitude,
              status: parkingCurbVo.status,
              parkingLotBillRuleId: parkingCurbVo.parkingLotBillRuleId,
              parkingLotBillRuleName: parkingCurbVo.parkingLotBillRuleName,
            };
            await save(obj);
            await closeLoading();
            await showTipMessage("添加成功");
            refresh = true;
            visible.value = false;
          } catch (e) {
            await closeLoading();
            await showErr(e);
            disabled.value = false;
          }
        }
      });
    };
    onMounted(async () => {
      try {
        let { data } = await allBillRules();
        billRules.push(...data);
      } catch (e) {
        await showErr(e);
      }
    });
    watch(parkingCurbVo, ({ lngLat, parkingLotBillRuleId }) => {
      parkingCurbVo.longitude = lngLat.split(",")[0];
      parkingCurbVo.latitude = lngLat.split(",")[1];

      if (parkingLotBillRuleId != null) {
        parkingCurbVo.parkingLotBillRuleName = billRules.filter(
          item => item.id == parkingLotBillRuleId,
        )[0].name;
      }
    });
    return {
      ...toRefs(pros),
      disabled,
      visible,
      afterClose,
      billRules,
      parkingCloseRules,
      parkingCurbVo,
      parkingStatus,
      validateInfos,
      doSubmit,
    };
  },
};
</script>

<style scoped></style>
